import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { CrtbSliceState, CrtbResponse } from './types';

const initialState: CrtbSliceState = {
  report: null,
  pollingStartedAt: null,
  needsVerification: false,
  canReRequest: false,
};

const creditReportCrtbSlice = createAppSlice({
  name: 'creditReportCrtb',
  initialState,
  reducers: {
    setCrtbReport(state, action: PayloadAction<CrtbResponse>) {
      state.report = action.payload;
    },
    clearCrtbReport(state) {
      state.report = null;
      state.pollingStartedAt = null;
      state.needsVerification = false;
      state.canReRequest = false;
    },
    setCrtbPollingStartedAt(state, action: PayloadAction<number>) {
      state.pollingStartedAt = action.payload;
    },
    setCrtbNeedsVerification(state, action: PayloadAction<boolean>) {
      state.needsVerification = action.payload;
    },
    setCrtbCanReRequest(state, action: PayloadAction<boolean>) {
      state.canReRequest = action.payload;
    },
  },
});

export const {
  setCrtbReport,
  clearCrtbReport,
  setCrtbPollingStartedAt,
  setCrtbNeedsVerification,
  setCrtbCanReRequest,
} = creditReportCrtbSlice.actions;

export default creditReportCrtbSlice.reducer;
